/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountData } from '../models/AccountData';
import type { SquareCardUpdateInfo } from '../models/SquareCardUpdateInfo';
import type { SquareCardUpdateRequest } from '../models/SquareCardUpdateRequest';
import type { SquareCardUpdateResult } from '../models/SquareCardUpdateResult';
import type { SquareConnectRequest } from '../models/SquareConnectRequest';
import type { SquareConnectUrlData } from '../models/SquareConnectUrlData';
import type { SquarePayRequest } from '../models/SquarePayRequest';
import type { SquarePayResult } from '../models/SquarePayResult';
import type { SquareStatusData } from '../models/SquareStatusData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SquareService {
  /**
   * Get Square Connect Url
   * @returns SquareConnectUrlData Successful Response
   * @throws ApiError
   */
  public static getSquareConnectUrl(): CancelablePromise<SquareConnectUrlData> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/square/connect_url',
    });
  }

  /**
   * Connect Square
   * @param requestBody
   * @returns AccountData Successful Response
   * @throws ApiError
   */
  public static connectSquare(requestBody: SquareConnectRequest): CancelablePromise<AccountData> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/square/connect',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Square Status
   * @returns SquareStatusData Successful Response
   * @throws ApiError
   */
  public static getSquareStatus(): CancelablePromise<SquareStatusData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/square/status',
    });
  }

  /**
   * Disconnect Square
   * @returns AccountData Successful Response
   * @throws ApiError
   */
  public static disconnectSquare(): CancelablePromise<AccountData> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/square/disconnect',
    });
  }

  /**
   * Square Pay
   * @param requestBody
   * @returns SquarePayResult Successful Response
   * @throws ApiError
   */
  public static squarePay(requestBody: SquarePayRequest): CancelablePromise<SquarePayResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/square/pay',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Square Card Update
   * @param token
   * @returns SquareCardUpdateInfo Successful Response
   * @throws ApiError
   */
  public static getSquareCardUpdate(token: string): CancelablePromise<SquareCardUpdateInfo> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/square/card_update',
      query: {
        token: token,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Update Square Card
   * @param requestBody
   * @returns SquareCardUpdateResult Successful Response
   * @throws ApiError
   */
  public static updateSquareCard(requestBody: SquareCardUpdateRequest): CancelablePromise<SquareCardUpdateResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/square/card_update',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
